import { render, staticRenderFns } from "./Error.vue?vue&type=template&id=7c5954d0&scoped=true&lang=pug&"
import script from "./Error.vue?vue&type=script&lang=js&"
export * from "./Error.vue?vue&type=script&lang=js&"
import style0 from "./Error.vue?vue&type=style&index=0&id=7c5954d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../Volumes/bsdcDoc/yimanDoc/htdocs/tocin_projects/tocin_web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c5954d0",
  null
  
)

export default component.exports